import * as yup from 'yup'
import { i18n } from 'src/provider/LocaleProvider'

type ErrorMessage = string

export const useValidationSchema = () =>
    yup.object().shape({
        email: yup
            .string<ErrorMessage>()
            .email(i18n.t('fields.email.invalid') as ErrorMessage)
            .required(i18n.t('fields.email.requiredCompany') as ErrorMessage),
    })
